import React, {Component} from 'react';
import BaseComponent from "../../../base/BaseComponent";
import {HEADER_HEIGHT} from "../../../constants";
import {
    Button,
    Input,
    Tabs,
    DatePicker,
    TreeSelect, Icon, Popconfirm, Modal, message, Tree, Badge,
} from "antd";
import {getColorByState} from "../../components/colorByState/colorByState";
import NewTable from "../baijiahao/NewTable";
import "./mineOrAllManuscript.css";
import {findUrlData, formatTime, generateTreeData, uuid} from "../../../utils";
import RmtPopconfirm from "../../components/rmtPopconfirm/rmtPopconfirm";
import ContributeTo from "./ContributeTo";
import site from "./images/site.png";
import {getInfoFromLocalStorage} from "../../../actions";
import {Scrollbars} from "react-custom-scrollbars";
import Photos from "../mediaJump/photos/photos";

const {TabPane} = Tabs;
const {Search} = Input;
const {RangePicker} = DatePicker;
const {confirm} = Modal;
const {TreeNode} = TreeSelect;
const doStoryState = {
    undo: '/cm-sites-pms/website/news/undo', // 撤稿
    doFirst: '/cm-sites-pms/website/news/doFirst', // 头条
    undoFirst: '/cm-sites-pms/website/news/undoFirst', // 取消头条
    doRecommend: '/cm-sites-pms/website/news/doRecommend', // 推荐
    undoRecommend: '/cm-sites-pms/website/news/undoRecommend', // 取消推荐
    doTop: '/cm-sites-pms/website/news/doTop', // 置顶
    undoTop: '/cm-sites-pms/website/news/undoTop', // 取消置顶
    needTime: ['doTop'], // 需要时间的接口
};

class MineOrAllManuscript extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            isMyManuscript: this.props.match.params["mine"] === 'true',
            tabKey: '全部',
            total: 0,
            hideOnSinglePage: true,
            defaultParams: {
                mediaId: this.props.match.params.mediaId,
                page: 1,
                size: 10,
                keywords: "",
                startTime: "",
                endTime: "",
                treeContentId: ""
            },
            startTime: null,
            endTime: null,
            dataSource: [],
            siteData: [],
            columnData: [],
            webNewsId: 0,
            loadListKey: uuid(),
            treeWithdrawData: [],
            treeNodeWithdrawVisible: false,
            bindUserList: [],
            dialogKey: uuid(),
            record: {},
            examineCount: 0,  //待我审核代办数量
        };
    }

    componentWillMount() {
        this.createPostMessage((e) => {
            let message = e['data'] ? JSON.parse(e['data'])['message'] : null;
            if (message == "请求刷新父页面") {
                this.screenList(this.state.tabKey);
            }
        }, "ManuscriptsSubmitted");
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.match.params.mediaId !== this.state.defaultParams.mediaId) {
            this.state.defaultParams.mediaId = nextProps.match.params.mediaId;
            this.setState({});
            this.screenList(this.state.tabKey);
            if (this.state.isMyManuscript || this.permissionCheck("pms:website:allStory")) {
                this.getColumnData(this.state.defaultParams.mediaId);
            }
            if (!this.state.isMyManuscript) {
                this.getSiteData();
                this.getBindUserList();
            }
        }
    }

    componentDidMount() {
        this.screenList(this.state.tabKey);
        this.getCountOfExamine();
        if (this.state.isMyManuscript || this.permissionCheck("pms:website:allStory")) {
            this.getColumnData(this.state.defaultParams.mediaId);
        }
        if (!this.state.isMyManuscript) {
            this.getSiteData();
            this.getBindUserList();
        }

    };

    componentWillUnmount() {

    }

    getBindUserList() {
        let url = "/cm-sites-pms/website/getWebSiteBindUserList";
        let params = {userId: window.top.currentUser.id};
        this.request({
            url,
            body: params,
            callBack: (data) => {
                let bindUserList = [];
                if (data && data.length) {
                    bindUserList = data;
                }
                this.setState({
                    bindUserList,
                })
            },
            errorCallBack: (e) => {
            },
        })
    }

    //获取所有网站类媒体
    getSiteData() {
        let url = "/cm-sites-pms/media/getAllWebSiteMedia";
        let params = {};
        this.request({
            url,
            body: params,
            callBack: (data) => {
                let siteData = [];
                if (data && data.length) {
                    siteData = data;
                }
                this.setState({
                    siteData,
                })
            },
            errorCallBack: (e) => {
            },
        })
    }

    //获取指定网站的栏目树
    getColumnData(siteId) {
        let url = "/cm-sites-pms/website/getColumnTreeByMediaId";
        let params = {
            mediaId: siteId
        };
        const treeDataIndex = {
            id: "contentId",
            title: "title",
            children: "subtree",
            key: "key"
        };
        this.request({
            url,
            body: params,
            callBack: (res) => {
                let columnData = [];
                if (res) {
                    columnData = generateTreeData([res], treeDataIndex);
                }
                this.setState({
                    columnData,
                })
            },
            errorCallBack: (e) => {
            },
        })
    }

    //获取列表数据
    getManuscriptList() {
        let {tabKey, defaultParams, isMyManuscript} = this.state;
        let navigationBarDate = isMyManuscript ? this.myTab() : this.allTab();
        // 根据 tabKey 获取 navigationBarDate 中对应的对象
        let thisTab = navigationBarDate.find(item => item.key === tabKey);
        // 根据上面获取的对象,取到url
        let url = thisTab.url;
        let newParams = JSON.parse(JSON.stringify(defaultParams));
        newParams.keywords = encodeURIComponent(newParams.keywords);
        newParams.mediaId = this.state.defaultParams.mediaId;
        //参数
        if (thisTab.params) {
            newParams = {
                ...newParams,
                ...thisTab.params
            }
        }
        this.request({
            url,
            body: newParams,
            callBack: (res) => {
                let dataSource = [];
                let total = 0;
                let hideOnSinglePage = true;
                if (res && res.data.length) {
                    total = res.count;
                    dataSource = res.data;
                    hideOnSinglePage = false;
                }
                this.setState({
                    total,
                    dataSource,
                    hideOnSinglePage
                }, () => {

                })
            },
            errorCallBack: (e) => {

            },
        })
    };

    // 获取待我审核代办数量
    getCountOfExamine() {
        let navigationBarDate = this.myTab();
        // 获取 navigationBarDate 中对应的对象
        let data = navigationBarDate.find(item => item.key === '待我审核');
        let title = '';
        let size = 10;
        let page = 1;
        let treeContentId = "";
        if (this.state.defaultParams) {
            //如果 URI 组件中含有分隔符，比如 ? 和 #，则应当使用 encodeURIComponent() 方法进行编码
            title = this.state.defaultParams.keywords;
            size = this.state.defaultParams.size;
            page = this.state.defaultParams.page;
            treeContentId = this.state.defaultParams.treeContentId
        }
        let params = data.params;
        params.title = title;
        params.page.size = size;
        params.page.start = page;
        params.contentId = treeContentId;
        let url = data.url;
        let that = this;
        this.request({
            url,
            method: 'post',
            body: params,
            contentType: 'json',
            callBack: function (res) {
                let total = 0;
                if (res && res.data && res.data.length) {
                    total = res.count;
                }
                that.setState({
                    examineCount: total,
                });
            },
        });
    }

    refreshList = (page = 1, pageSize = 10) => {
        this.state.hideOnSinglePage = false;
        this.state.defaultParams.page = page;
        this.state.defaultParams.size = pageSize;
        this.screenList(this.state.tabKey);
    }

    render() {
        let {dataSource, defaultParams, total, hideOnSinglePage} = this.state;
        let props = {
            initDataSource: this.refreshList,
            dataSource: dataSource, //表格数据
            showBorderBottom: true,
            columns: this.getColumns(),  //表格表头
            defaultParams: {start: defaultParams.page, size: defaultParams.size},
            total: total,
            hideOnSinglePage: hideOnSinglePage,
            height: window.innerHeight - parseInt(HEADER_HEIGHT) - 189,
        };
        return (
            <div style={{margin: "15px 15px 0px 15px", borderRadius: 5}}>
                <div style={{backgroundColor: "#fff", borderRadius: "5px 5px 0px 0px"}}>
                    {this.renderTabs()}
                    {this.renderBtn()}
                    {this.renderScreen()}
                </div>
                <div style={{backgroundColor: "#fff", padding: "24px 32px 0px 32px", borderRadius: "0px 0px 5px 5px"}}
                     key={this.state.loadListKey}>
                    <NewTable {...props}/>
                </div>
                {/*投稿至弹窗*/}
                <ContributeTo ref={(c) => this.contributeTo = c} webNewsId={this.state.webNewsId}
                              refreshList={this.refreshList}/>
                {this.renderWithdrawModal()}
                {/*组图*/}
                <Photos
                    key={this.state.dialogKey}
                    ref={ref => this.photos = ref}
                    btnName={'新增组图'}
                    isShowPhotosBtn={false}
                    dynamicParams={{
                        mediaId: this.state.record.mediaId,
                        treeId: this.state.record.treeId,
                        contentId: this.state.record.contentId,
                    }}
                    onOkCall={() => {
                        this.screenList(this.state.tabKey);
                        this.setState({dialogKey: uuid()})
                    }}/>
            </div>
        );
    }

    renderTabs() {
        let {isMyManuscript, examineCount} = this.state;
        let navigationBarDate = isMyManuscript ? this.myTab() : this.allTab();
        return (
            <div style={{borderBottom: "1px solid #e8e8e8", padding: "3px 32px 0px 32px"}}>
                {
                    (navigationBarDate && navigationBarDate.length)
                        ?
                        (<Tabs className={"tabs_mineOrAll"} defaultActiveKey="1" onChange={this.tabChange}>
                            {
                                navigationBarDate.map((item, index) => {
                                    if (item.key == "待我审核") {
                                        return (
                                            <TabPane tab={
                                                <>
                                                    <span style={{position: "absolute", left: "-17px", top: "11px", height: "23px", border: "1px solid #aaa", backgroundColor: "#aaa", display: "inline-block"}} />
                                                    <Badge offset={[14,-5]} count={examineCount}>
                                                        <span>{item.key}</span>
                                                    </Badge>
                                                </>
                                            } key={item.key}/>
                                        )
                                    }
                                    return (
                                        <TabPane tab={item.title} key={item.key}/>
                                    )
                                })
                            }
                        </Tabs>)
                        : null
                }
                <style>{`
                .tabs_mineOrAll .ant-tabs-bar{border-bottom: 0;}
                .tabs_mineOrAll .ant-tabs-nav-container{margin-bottom: 0;font-size: 14px;}
                `}</style>
            </div>
        )
    };

    renderScreen() {
        let {isMyManuscript} = this.state;
        const itemIcon = <img src={site}/>;
        const itemIcon2 = <Icon type="file-text"/>;
        const ExpandedIcon = <Icon style={{color: "#ffcd2c"}} type="folder-open" theme="filled"/>;
        const ClosedIcon = <Icon style={{color: "#ffcd2c"}} type="folder" theme="filled"/>;
        const siteLoop = (data) => {
            return data.map(item => {
                let TitleIcon;
                if (!item.medias) {
                    TitleIcon = itemIcon;
                }
                // 最终的展示 title
                let title = <div style={{display: "flex", alignItems: "center"}}>
                    <div>{TitleIcon}</div>
                    <div title={item.name} style={{
                        marginLeft: "8px",
                        width: 120,
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis"
                    }}>{item.name}</div>
                </div>;
                if (item.medias) {
                    return <TreeNode selectable={false} title={<div title={item.deptName} style={{
                        display: "flex",
                        alignItems: "center",
                    }}><span style={{
                        display: "inline-block",
                        alignItems: "center",
                        width: 170,
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                    }}>{item.deptName}</span></div>} key={item._id}>
                        {item.medias && item.medias.length ? siteLoop(item.medias) : ""}
                    </TreeNode>;
                }
                return <TreeNode value={item._id} title={title} key={item._id} id={item._id}/>;
            });
        };
        const columnLoop = (data) => {
            return data.map(item => {
                let TitleIcon;
                if (item.children && item.children.length) {
                    if (this.state.defaultParams.treeContentId === item.id) {
                        TitleIcon = ExpandedIcon;
                    } else {
                        TitleIcon = ClosedIcon;
                    }
                } else {
                    TitleIcon = itemIcon2;
                }
                // 最终的展示 title
                let title = <div style={{display: "flex", alignItems: "center"}}>
                    <div>{TitleIcon}</div>
                    <div title={item.title} style={{
                        marginLeft: "8px",
                        width: 120,
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis"
                    }}>{item.title}</div>
                </div>;
                return <TreeNode value={item.id} title={title} key={item.key} id={item.id}>
                    {item.children && item.children.length ? columnLoop(item.children) : ""}
                </TreeNode>;
            });
        };
        let allStoryLimits = this.permissionCheck("pms:website:allStory");
        return (
            <div style={{padding: "24px 32px 0px 32px"}} className={"screenStyle"}>
                {this.state.tabKey === "已发布" ?
                    <div style={{float: 'left', marginRight: 24}}>
                        <div className={'manuscriptScreenTitle'} style={{float: 'left'}}>发布时间：</div>
                        <div style={{float: 'left'}}>
                            <RangePicker value={[this.state.startTime, this.state.endTime]}
                                         format={"YYYY-MM-DD"}
                                         placeholder={["开始时间", "结束时间"]}
                                         style={{width: 270}}
                                         onChange={(date) => {
                                             this.state.startTime = date[0];
                                             this.state.endTime = date[1];
                                             this.state.defaultParams.startTime = date[0];
                                             this.state.defaultParams.endTime = date[1];
                                             this.state.defaultParams.page = 1;
                                             let startTime = this.state.defaultParams.startTime ? new Date(this.state.defaultParams.startTime.format('YYYY-MM-DD') + ' 00:00:00').getTime() : "";
                                             let endTime = this.state.defaultParams.endTime ? new Date(this.state.defaultParams.endTime.format('YYYY-MM-DD') + ' 23:59:59').getTime() : "";
                                             this.setState({
                                                 defaultParams: {
                                                     ...this.state.defaultParams,
                                                     startTime,
                                                     endTime
                                                 }
                                             }, () => {
                                                 this.screenList(this.state.tabKey);
                                             });
                                         }}
                            />
                        </div>
                    </div> : null}
                <div style={{float: 'left', marginRight: 24}}>
                    <div style={{float: 'left'}}>
                        <Search
                            allowClear={true}
                            placeholder={"请输入关键字"}
                            value={this.state.defaultParams.keywords}
                            onChange={(e) => {
                                this.onSearch('onChange', e)
                            }}
                            onSearch={(e) => {
                                this.onSearch('onSearch', e)
                            }}
                            style={{width: 224, height: 32}}
                        />
                    </div>
                </div>
                {
                    (!isMyManuscript && allStoryLimits) ?
                        <div style={{float: 'left', marginRight: 24}}>
                            <div style={{float: 'left', width: 224}}>
                                <TreeSelect
                                    value={this.state.defaultParams.mediaId ? this.state.defaultParams.mediaId : undefined}
                                    style={{width: '100%'}}
                                    placeholder={"请选择站点"}
                                    dropdownStyle={{maxHeight: 250, width: 224}}
                                    treeDefaultExpandAll
                                    multiple={false}
                                    onChange={(e) => {
                                        if (e === null) return;
                                        this.state.defaultParams.mediaId = e || "";
                                        this.state.defaultParams.page = 1;
                                        this.state.defaultParams.size = 10;
                                        this.state.defaultParams.treeContentId = undefined;
                                        this.setState({}, () => {
                                            if (e !== undefined) {
                                                this.getColumnData(e)
                                            }
                                            this.screenList(this.state.tabKey);
                                        })
                                    }}>
                                    {siteLoop(this.state.siteData)}
                                </TreeSelect></div>
                        </div> : null
                }
                {
                    (isMyManuscript || (!isMyManuscript && allStoryLimits)) ?
                        <div style={{float: 'left', marginRight: 24}}>
                            <div style={{float: 'left', width: 224}} key={uuid()}>
                                <TreeSelect
                                    style={{width: "100%"}}
                                    allowClear
                                    placeholder={"请选择栏目"}
                                    dropdownStyle={{maxHeight: 250, width: 224}}
                                    multiple={false}
                                    treeDefaultExpandAll
                                    value={this.state.defaultParams.treeContentId ? this.state.defaultParams.treeContentId : undefined}
                                    onChange={(value) => {
                                        if (value === null) return;
                                        this.state.defaultParams.treeContentId = value;
                                        this.state.defaultParams.page = 1;
                                        this.state.defaultParams.size = 10;
                                        this.setState({}, () => {
                                            this.screenList(this.state.tabKey);
                                        });
                                    }}
                                >
                                    {columnLoop(this.state.columnData)}
                                </TreeSelect></div>
                        </div> : null}
                <div style={{float: 'left', marginRight: 24}}>
                    <div style={{float: 'left'}}>
                        <Button type={"primary"} onClick={() => {
                            this.revert()
                        }}>重置</Button>
                    </div>
                </div>
                <div style={{clear: 'both'}}/>
                <style>
                    {`
                    .screenStyle .ant-input,.ant-select-selection {
                                background-color: #f5f8fc;
                            }
                     `}
                </style>
            </div>
        )
    };

    // 稿件状态修改，栏目选择弹窗
    renderWithdrawModal = () => {
        const {treeWithdrawData} = this.state;
        return (
            <Modal
                centered={true}
                title={this.state.renderWithdrawModalTitle}
                visible={this.state.treeNodeWithdrawVisible}
                onOk={() => {
                    this.onStoryStateOk()
                }}
                onCancel={() => {
                    this.setState({treeNodeWithdrawVisible: false, checkedWithdrawKeys: []})
                }}
                width={400}
            >
                <Scrollbars style={{height: 350,}}>
                    {(treeWithdrawData && treeWithdrawData.length) ? <Tree
                        showIcon
                        checkable
                        defaultExpandParent={true}
                        defaultExpandAll={true}
                        // expandedKeys={this.state.expandedKeys}
                        autoExpandParent={true}
                        checkedKeys={this.state.checkedWithdrawKeys}
                        // selectedKeys={this.state.selectedKeys}
                        // onExpand={this.onExpand}
                        // onSelect={this.onSelect}
                        onCheck={this.onWithdrawCheck}
                    >
                        {this.renderWithdrawTreeNodes(treeWithdrawData)}
                    </Tree> : null}
                </Scrollbars>
            </Modal>
        )
    };

    // 稿件状态操作，节点选择弹窗确认事件
    onStoryStateOk = (time) => {
        if (!time && doStoryState.needTime.indexOf(this.state.urlKey) > -1) {
            return this.setState({treeNodeWithdrawVisible: false, selectTimeVisible: true})
        }
        if (this.state.checkedWithdrawKeys && this.state.checkedWithdrawKeys.length) {
            let treeContentIds = this.state.checkedWithdrawKeys.join(',');
            this.state.treeNodeWithdrawVisible = false;
            this.state.checkedWithdrawKeys = [];
            this.doStoryState(treeContentIds, this.state.urlKey, time)
        }
    };

    // 稿件状态修改（置顶头条推荐）栏目选择
    onWithdrawCheck = (checkedWithdrawKeys, info) => {
        let newChecked = checkedWithdrawKeys;
        // console.log('newChecked       ', newChecked);
        // console.log('this.state.record       ', this.state.record);
        if (checkedWithdrawKeys && checkedWithdrawKeys.length && (checkedWithdrawKeys.indexOf(this.state.record.contentId + '') > -1)) {
            newChecked = [this.state.record.contentId, ...this.state.record.deliveryNews.map(item => item.contentId)];
            message.destroy();
            message.warning('选择主节点后会默认选中其他节点');
        }
        this.setState({checkedWithdrawKeys: newChecked})
    };

    renderWithdrawTreeNodes = (data) =>
        data.map(item => {
            if (item.child) {
                return (
                    <TreeNode disabled={true} title={this.renderWithdrawTitle("folder-open", item)} key={item.id}
                              dataRef={item}>
                        {this.renderWithdrawTreeNodes(item.child)}
                    </TreeNode>
                );
            }
            return <TreeNode key={item.id} title={this.renderWithdrawTitle("file-text", item)}/>;
        });

    renderWithdrawTitle = (type, item) => {
        return (
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: 190,}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    <Icon type={type}/>
                    <span style={{
                        width: 160,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                    }}
                    >{item.name}</span>
                </div>
            </div>
        )
    };

    //搜索功能
    onSearch = (type, e) => {
        let {defaultParams} = this.state;
        switch (type) {
            case 'onChange':
                defaultParams['keywords'] = e.target.value;
                return this.setState({});
            case 'onSearch':
                defaultParams['keywords'] = e;
                defaultParams['page'] = 1;
                break;
        }
        this.screenList(this.state.tabKey);
    };

    renderBtn() {
        return (
            // 新增文章,网络管理,访问网站,搜索框
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: "center",
                padding: "24px 32px 0px 32px"
            }}>
                <div style={{display: 'flex'}}>
                    <Button style={{marginRight: 24}} type={'primary'} onClick={() => {
                        this.addStory()
                    }}>新增文章</Button>
                </div>
                <div style={{display: 'flex'}}>
                    <div style={{
                        color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"),
                        fontSize: 14,
                        fontWeight: 400,
                        textAlign: "left",
                        marginLeft: 16,
                        cursor: "pointer"
                    }}
                         onClick={() => {
                             this.websiteManagementButton()
                         }}>网站管理
                    </div>
                    <div style={{
                        color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"),
                        fontSize: 14,
                        fontWeight: 400,
                        textAlign: "left",
                        marginLeft: 16,
                        cursor: "pointer"
                    }}
                         onClick={() => {
                             this.visitWebsite()
                         }}>访问网站
                    </div>
                </div>
            </div>
        )
    }

    //访问网站跳转
    visitWebsite = () => {
        this.request({
            url: '/cm-sites-pms/website/access',
            body: {mediaId: this.props.match.params.mediaId},
            callBack: (res) => {
                if (res) {
                    window.open(res);
                }
            }
        })
    };

    //网站管理跳转
    websiteManagementButton = () => {
        this.request({
            url: '/cm-sites-pms/website/manage',
            body: {mediaId: this.props.match.params.mediaId},
            callBack: (res) => {
                if (res) {
                    this.openLoginPage(res.url, res.account, res.token, res.action)
                }
            }
        })
    };

    //网站管理
    openLoginPage(url, account, token, action) {
        let params = [];
        params.push({name: "account", value: account});
        params.push({name: "token", value: token});
        params.push({name: "action", value: action});
        this.openLoginPagePost(url, params);
        return false;
    };

    //网站管理
    openLoginPagePost(URL, PARAMTERS) {
        //创建form表单
        var temp_form = document.createElement("form");
        temp_form.action = URL;
        //如需打开新窗口，form的target属性要设置为'_blank'
        temp_form.target = "_self";
        temp_form.method = "post";
        temp_form.style.display = "none";
        temp_form.target = "_blank";
        //添加参数
        for (var item in PARAMTERS) {
            var opt = document.createElement("textarea");
            opt.name = PARAMTERS[item].name;
            opt.value = PARAMTERS[item].value;
            temp_form.appendChild(opt);
        }
        document.body.appendChild(temp_form);
        //提交数据
        temp_form.submit();
    };

    //新增文章
    addStory = () => {
        //获取网站流程的code
        let activitiConfName = this.sysConfigGetValueByKey("editor.activiti.conf.name.wzlc", "activitiTreeRoot-xlc-wzlc");
        let treeId = "";
        let mediaId = this.props.match.params.mediaId;
        let contentId = "";
        window.openEditById({
            configName: "webEditor",
            id: 0, params: {
                activitiConfName, treeId, mediaId, contentId, checkMainColumn: true
            }
        });
    };

    //tab栏切换
    tabChange = (key, isTabChange = true) => {
        this.state.tabKey = key;
        if (isTabChange) {
            this.state.defaultParams.size = 10;
            this.state.defaultParams.page = 1;
            this.state.defaultParams.startTime = "";
            this.state.defaultParams.endTime = "";
            this.state.startTime = null;
            this.state.endTime = null;
        }
        this.screenList(key);
    };

    getTabDataByKey = (key) => {
        let {isMyManuscript} = this.state;
        let data = isMyManuscript ? this.myTab() : this.allTab();
        return data.find(item => item.key === key);
    };

    screenList(key) {
        let data = this.getTabDataByKey(key);
        if (["待我审核", "我已审核"].indexOf(this.state.tabKey) > -1) {
            return this.getActivityDataSource(data)
        }
        this.state.loadListKey = uuid();
        this.getManuscriptList();
    }

    revert() {
        this.setState({
            defaultParams: {
                mediaId: this.props.match.params.mediaId,
                page: 1,
                size: 10,
                keywords: "",
                startTime: "",
                endTime: "",
                treeContentId: ""
            },
            startTime: null,
            endTime: null,
        }, () => {
            this.screenList(this.state.tabKey);
        })
    }

    getActivityDataSource = (data) => {
        let title = '';
        let size = 10;
        let page = 1;
        let treeContentId = "";
        if (this.state.defaultParams) {
            //如果 URI 组件中含有分隔符，比如 ? 和 #，则应当使用 encodeURIComponent() 方法进行编码
            title = this.state.defaultParams.keywords;
            size = this.state.defaultParams.size;
            page = this.state.defaultParams.page;
            treeContentId = this.state.defaultParams.treeContentId
        }
        let params = data.params;
        params.title = title;
        params.page.size = size;
        params.page.start = page;
        params.contentId = treeContentId;
        let url = data.url;
        let that = this;
        this.request({
            url,
            method: 'post',
            body: params,
            contentType: 'json',
            callBack: function (res) {
                let dataSource = [];
                let total = 0;
                let hideOnSinglePage = true;
                if (res && res.data && res.data.length) {
                    total = res.count;
                    dataSource = res.data;
                    hideOnSinglePage = false;
                }
                that.setState({
                    total: total,
                    hideOnSinglePage,
                    dataSource: dataSource && dataSource.length ? dataSource.map(item => item.data) : [],
                })
                if (data.key == '待我审核') {
                    that.setState({
                        examineCount: total,
                    });
                }
            },
            errorCallBack: function (e) {
            }

        });
    };

    editPhotos(record) {
        this.setState({
            record
        }, () => {
            this.photos.showEditModal(record)
        })
    }

    // 点击标题进入稿件编辑器
    editStory(id, record) {
        // console.log(record)
        let activitiConfName = this.sysConfigGetValueByKey("editor.activiti.conf.name.wzlc", "activitiTreeRoot-xlc-wzlc");
        let treeId = record.treeId;
        let mediaId = record.mediaId;
        let contentId = record.contentId;
        let noPublishConfig = this.sysConfigGetValueByKey("materialCenter.publishBtn.exclude", "已发布");
        let mustNotShowPublishBtn = noPublishConfig.indexOf(record.statusName) > -1 ?false  : true
        mustNotShowPublishBtn = false; // 这个判断在编辑器里面已经执行了，外层不用再执行，稿件发布后这个参数就不对了（在不退出编辑器的情况下）。这里应该做的是当前稿件当前人永远不能发布的情况。
        const editorWindow = window.openEditById({
            configName: "webEditor",
            id: id, params: {
                activitiConfName,
                treeId,
                mediaId,
                contentId,
                storyType: "default",
                checkMainColumn: true,
                mustNotShowPublishBtn
            }
        });
        this.state.editorWindow = editorWindow;
    };

    // 表头
    getColumns = () => {
        return (
            [
                {
                    title: '标题',
                    key: 'title',
                    dataIndex: "title",
                    width: 700,
                    render: (text, record) => {
                        let createName = record.variableFields.author || record.creatorName;
                        return (
                            <div style={{display: "flex", alignItems: "center", cursor: "pointer"}} onClick={() => {
                                if(record.atlasList && Array.isArray(record.atlasList) && record.atlasList.length > 0) {
                                    this.editPhotos(record);
                                } else {
                                    this.editStory(record.id,record)
                                }
                            }}>
                                <div>
                                    <div title={record.title} style={{
                                        fontSize: "14px",
                                        color: "rgba(0,0,0,0.85)",
                                        fontWeight: 400,
                                        maxWidth: 660,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        height: "22px",
                                        lineHeight: "22px"
                                    }}>{record.title}</div>
                                    <div className={"manuscriptTitleInfo"}
                                         style={{display: "flex", alignItems: "center",  overflow: "hidden",
                                             textOverflow: "ellipsis",
                                             whiteSpace: "nowrap"}}>
                                        <div style={{display: "flex", alignItems: "center"}}>
                                            <div style={{width:'45px'}}>作者：</div>
                                            <div title={createName} style={{
                                                maxWidth: 240,
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap"
                                            }}>{createName}</div>
                                        </div>
                                        <div> <span
                                            style={{marginLeft: 24}}>创建时间：</span><span>{record.createTime ? formatTime(record.createTime) : ""}</span></div>
                                      <div> <span
                                          style={{marginLeft: 24}}>修改时间：</span><span>{record.updateTime ? formatTime(record.updateTime) : ""}</span></div>

                                    </div>
                                </div>
                                <div style={{marginLeft: 7}}>
                                    {record.titlePic ? <img width={32} height={32} style={{objectFit: "cover"}}
                                                            src={record.titlePic}/> : null}
                                </div>
                            </div>
                        )
                    },
                },
                {
                    title: '栏目',
                    dataIndex: 'treeName',
                    key: 'treeName',
                    width: 150,
                    render: (text, record) => {
                        return (
                            <div style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}>{text}</div>
                        )
                    }
                },
                {
                    title: '状态',
                    key: 'statusName',
                    dataIndex: "statusName",
                    width: 150,
                    render: (text) => {
                        let backgroundColor = getColorByState(text);
                        return (
                            <div style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}><span style={{
                                display: "inline-block",
                                width: "8px",
                                height: "8px",
                                borderRadius: "50%",
                                backgroundColor: backgroundColor,
                                marginRight: "5px",
                                marginBottom: "1px"
                            }}/>{text}</div>
                        )
                    }
                },
                {
                    title: '操作',
                    key: 'action',
                    dataIndex: 'action',
                    width: 250,
                    render: (text, record, index) => {
                        let hasMore = record.deliveryNews && record.deliveryNews.length > 0;
                        let title = hasMore ? '该文章同时发布到多个栏目，请问需要同步撤除其他栏目吗？' : '确定要撤稿吗？';
                        let urlKey = 'undo';
                        let bindUserIds = [];
                        let isShowPreview = true;
                        this.state.bindUserList.length && this.state.bindUserList.forEach(item => {
                            if (item.vsbUserAccount) {
                                bindUserIds.push(item.mediaId);
                            }
                        })
                        if (bindUserIds.length && bindUserIds.indexOf(record.mediaId) === -1) {
                            isShowPreview = false;
                        }
                        return (
                            <div className={'a'}>
                                {isShowPreview ?
                                    <Button type={'link'} onClick={() => {
                                        if (record.linkurl) {
                                            window.open(record.linkurl, "newwindow");
                                            return false
                                        }
                                        if (record && record.id) {
                                            this.previewCall(record);
                                            return false
                                        }
                                    }} style={{marginLeft: -15}}>预览</Button> : null
                                }
                                {
                                    (record.statusName === "发布" || record.statusName === "已发布" || record.statusName === "定时发布") ?
                                        <RmtPopconfirm
                                            key={(record.id + index)}
                                            visible={record.undo}
                                            title={<div style={{marginLeft: 10}}>{title}</div>}
                                            icon={<Icon type={'question-circle'}
                                                        style={{color: '#faad14', fontSize: 22}}/>}
                                            footer={
                                                <div style={{display: 'flex', justifyContent: 'flex-end',}}>
                                                    <Button onClick={() => {
                                                        this.state.dataSource[index].undo = false;
                                                        this.setState({})
                                                    }}>取消</Button>
                                                    {
                                                        hasMore ?
                                                            <Button onClick={() => {
                                                                this.state.treeWithdrawData = [];
                                                                let deliveryNews = [...record.deliveryNews, {
                                                                    contentId: record.contentId,
                                                                    mediaId: record.mediaId,
                                                                    contentName: record.contentName,
                                                                    mediaName: record.mediaName,
                                                                }];
                                                                this.setTreeWithdrawData(deliveryNews);
                                                                this.state.dataSource[index].undo = false;
                                                                this.setState({
                                                                    renderWithdrawModalTitle: '选择需要撤稿的栏目',
                                                                    treeNodeWithdrawVisible: true,
                                                                })
                                                            }}>选择栏目</Button>
                                                            : null
                                                    }
                                                    {
                                                        (hasMore && this.state.isMyManuscript) ?
                                                            <Button onClick={() => {
                                                                let treeContentIds = record.contentId;
                                                                this.state.dataSource[index].undo = false;
                                                                this.setState({});
                                                                this.doStoryState(treeContentIds, 'undo')
                                                            }}>当前栏目</Button>
                                                            : null
                                                    }
                                                    <Button onClick={() => {
                                                        let treeContentIds = record.contentId;
                                                        if (record && record.deliveryNews && record.deliveryNews.length) {
                                                            record.deliveryNews.forEach(item => {
                                                                treeContentIds += (',' + item.contentId)
                                                            })
                                                        }
                                                        this.state.dataSource[index].undo = false;
                                                        this.setState({});
                                                        this.doStoryState(treeContentIds, 'undo')
                                                    }} type={'primary'}>{hasMore ? '全部撤稿' : '撤稿'}</Button>
                                                </div>
                                            }
                                        >
                                            <Button type={'link'} onClick={() => {
                                                this.state.webNewsId = record.id;
                                                this.state.record = record;
                                                this.state.dataSource[index].undo = true;
                                                this.state.urlKey = urlKey;
                                                this.setState({})
                                            }} style={{marginLeft: -15}}>撤稿</Button>
                                            {
                                                (record.atlasList && Array.isArray(record.atlasList) && record.atlasList.length > 0) ? "" :
                                                    (<Button type={'link'} onClick={() => {
                                                        this.contributeTo.openContributeModal();
                                                        this.setState({webNewsId: record.id})
                                                    }} style={{marginLeft: -15}}>投稿至</Button>)
                                            }
                                        </RmtPopconfirm>
                                        : null
                                }
                                {
                                    (
                                        record.statusName.indexOf('草稿') > -1 ||
                                        record.statusName.indexOf('撤稿') > -1 ||
                                        record.statusName.indexOf('弃用') > -1
                                    ) ? <Button type={'link'} onClick={() => {
                                            let that = this
                                            confirm({
                                                title: '确定要删除吗?',
                                                content: '',
                                                onOk() {
                                                    that.delStory(record.id);
                                                },
                                                onCancel() {
                                                    console.log('Cancel');
                                                },
                                            });
                                        }} style={{marginLeft: -15}}>删除</Button>
                                        : null
                                }
                                {
                                    record.statusName == '发布失败' ? (
                                        <span className={"Failure"}>
                                            <Popconfirm getPopupContainer={triggerNode => triggerNode.parentNode}
                                                        title={this.state.errorInfoValue}>
                                                <Button style={{marginLeft: -7}} size={'small'} type={'link'}
                                                        onClick={() => {
                                                            this.getFailure(record.id)
                                                        }}>失败原因</Button>
                                            </Popconfirm>
                                            <style>{`.Failure .ant-popover-buttons{display:none !important;} `}</style>
                                        </span>) : null
                                }
                            </div>
                        )
                    },
                },
            ]
        )
    };

    // 删除稿件
    delStory = (webNewsId) => {
        if (!webNewsId) return message.info('数据丢失');
        this.request({
            url: "/cm-sites-pms/website/news/deleteById",
            method: "post",
            body: {webNewsId},
            callBack: (res) => {
                message.success('删除成功！');
                this.screenList(this.state.tabKey);
            }
        })
    };

    //失败原因
    getFailure(id) {
        this.request({
            url: "/cm-sites-pms/index/publishLog",
            body: {id: id},
            callBack: (data) => {
                let errorInfoValue = ""
                if (data) {
                    errorInfoValue = data.errorInfo
                }
                this.setState({errorInfoValue})

            }
        })
    }

    //稿件状态操作
    doStoryState = (treeContentIds, urlKey, time) => {
        let url = '/cm-sites-pms/website/news/undo';
        if (!url) return false;
        let body = {treeContentIds, webNewsId: this.state.webNewsId};
        if (time) body = {...body, ...time};
        this.request({
            url,
            method: 'post',
            body,
            callBack: (res) => {
                if(res){
                    message.success('操作成功');
                    this.updateProcessAndData(res);
                }
                this.screenList(this.state.tabKey);
            }
        })
    };

    // 更新流程稿件
    updateProcessAndData(body) {
        this.request({
            url: "/cm-sites-sys/process/updateProcessAndData",
            method: "post",
            contentType: "json",
            body: {
                title: body?.title,
                bizKey: body?.id,
                data: body,
            },
            callBack: (res) => {

            }
        })
    };

    setTreeWithdrawData = (deliveryNews, config = {}) => {
        deliveryNews.forEach(item => {
            let index = this.state.treeWithdrawData.findIndex(item2 => item2.id == item.mediaId);
            if (item[config.key] == config.val) {
                if (index < 0) {
                    this.state.treeWithdrawData.push({
                        id: item.mediaId,
                        name: item.mediaName,
                        child: [
                            {
                                id: item.contentId,
                                name: item.contentName,
                            }
                        ]
                    })
                } else {
                    let index2 = this.state.treeWithdrawData[index].child.findIndex(item3 => item3.id == item.contentId);
                    if (index2 < 0) {
                        this.state.treeWithdrawData[index].child.push({
                            id: item.contentId,
                            name: item.contentName,
                        })
                    }
                }
            }
        });
    };

    //预览
    previewCall = (record) => {
        this.request({
            url: '/cm-sites-pms/website/news/getPreviewParam',
            body: {contentId: record.contentId, webNewsId: record.id},
            callBack: (res) => {
                if (res) {
                    this.openPreviewPage(res.url,
                        {
                            account: res.account,
                            token: res.token,
                            action: res.action,
                            newsid: res.newsid,
                            type: res.type,
                            owners: res.owners,
                        }
                    )
                }
            }
        })
    };

    //预览
    openPreviewPage(URL, PARAMTERS) {
        //创建form表单
        var temp_form = document.createElement("form");
        temp_form.action = URL;
        //如需打开新窗口，form的target属性要设置为'_blank'
        temp_form.target = "_self";
        temp_form.method = "post";
        temp_form.style.display = "none";
        temp_form.target = "_blank";
        //添加参数
        for (var key in PARAMTERS) {
            var opt = document.createElement("textarea");
            opt.name = key;
            opt.value = PARAMTERS[key];
            temp_form.appendChild(opt);
        }
        document.body.appendChild(temp_form);
        //提交数据
        temp_form.submit();
    };

    //我的稿件tab
    myTab = () => {
        return (
            [
                {
                    key: '全部',
                    title: '全部',
                    url: '/cm-sites-pms/website/news/myAllNews',
                },
                {
                    key: '草稿',
                    title: '草稿',
                    url: '/cm-sites-pms/website/news/myAllNewsByStatus',
                    params: {
                        status: "草稿"
                    }
                },
                {
                    key: '审核中',
                    title: '审核中',
                    url: '/cm-sites-pms/website/news/myAllAudit'
                },
                {
                    key: '已弃用',
                    title: '已弃用',
                    url: '/cm-sites-pms/website/news/myAllNewsByStatus',
                    params: {
                        status: "已弃用"
                    }
                },
                {
                    key: '已撤稿',
                    title: '已撤稿',
                    url: '/cm-sites-pms/website/news/myAllNewsByStatus',
                    params: {
                        status: "已撤稿"
                    }
                },
                {
                    key: '已发布',
                    title: '已发布',
                    url: '/cm-sites-pms/website/news/myAllNewsByStatus',
                    params: {
                        status: "已发布"
                    }
                },
                {
                    key: '待我审核',
                    // title: <span><span style={{position: "absolute", left: "-17px", top: "11px", height: "23px", border: "1px solid #aaa", backgroundColor: "#aaa", display: "inline-block"}} />待我审核</span>,
                    title: '待我审核',
                    url: '/cm-sites-sys/process/getTodoList',
                    params: {
                        showData: true,
                        operatorUser: this.getInfo().currentUser.id,
                        fieldQuery: {
                            queryRelationTypeEnum:"AND",
                            queryList: [
                                {
                                    fieldName: "processData.data.mediaId",
                                    queryTypeEnum: "IS",
                                    valueTypeEnum: "STRING",
                                    value: this.state.defaultParams.mediaId,
                                    queryRelationTypeEnum: "AND",
                                    queryList: null
                                },
                            ]
                        },
                        activitiCategoryKeys: ['webNews'],
                        title: '',
                        page: {
                            start: 1,
                            size: 10,
                        }
                    }
                },
                {
                    key: '我已审核',
                    title: '我已审核',
                    url: '/cm-sites-sys/process/getMyFinished',
                    params: {
                        showData: true,
                        operatorUser: this.getInfo().currentUser.id,
                        activitiCategoryKeys: ['webNews'],
                        title: '',
                        page: {
                            start: 1,
                            size: 10,
                        }
                    }
                },
            ]
        )
    }

    //全部稿件tab
    allTab = () => {
        return (
            [
                {
                    key: '全部',
                    title: '全部',
                    url: '/cm-sites-pms/website/news/allNews'
                },
                {
                    key: '审核中',
                    title: '审核中',
                    url: '/cm-sites-pms/website/news/allAudit'
                },
                {
                    key: '已弃用',
                    title: '已弃用',
                    url: '/cm-sites-pms/website/news/allNewsByStatus',
                    params: {
                        status: "已弃用"
                    }
                },
                {
                    key: '已撤稿',
                    title: '已撤稿',
                    url: '/cm-sites-pms/website/news/allNewsByStatus',
                    params: {
                        status: "已撤稿"
                    }
                },
                {
                    key: '已发布',
                    title: '已发布',
                    url: '/cm-sites-pms/website/news/allNewsByStatus',
                    params: {
                        status: "已发布"
                    }
                }
            ]
        )
    }

}


export default MineOrAllManuscript;